// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvaFranquiaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /franquias/salvaFranquia
 *
 * Creates or updates a franchise record.
 */
import { registerContract } from './validate'

export interface Franquias_SalvaFranquiaInput {
Nome: string
ID?: number
RazaoSocial?: string
CNPJ?: string
InscricaoEstadual?: string
InscricaoMunicipal?: string
Email?: string
Site?: string
Pais?: string
Idioma?: string
Ativo?: number
}

registerContract('Franquias_SalvaFranquiaInput', {
  Nome:               { type: 'string',  required: true },
  ID:                 { type: 'number',  required: false },
  RazaoSocial:        { type: 'string',  required: false },
  CNPJ:               { type: 'string',  required: false },
  InscricaoEstadual:  { type: 'string',  required: false },
  InscricaoMunicipal: { type: 'string',  required: false },
  Email:              { type: 'string',  required: false },
  Site:               { type: 'string',  required: false },
  Pais:               { type: 'string',  required: false },
  Idioma:             { type: 'string',  required: false },
  Ativo:              { type: 'number',  required: false },
})
